import { MoreSmall } from "@wix/wix-ui-icons-common";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context";
import { ClickOutside } from "./../../ui-components";
import styles from "../statics/styles/audio.rtlignore-scss";
import { AUDIO_CONTEXT_MENU } from "./data-hooks";
import DropdownMenu from "./DropdownMenu";
const ContextMenu = ({
  onClickOutside,
  contextMenuData,
  playBackMenuData,
  showContextMenu,
  showPlaybackMenu,
  onClick
}) => {
  const { tabIndex } = useContext(RicosContext);
  const onKeyPress = (e) => {
    if (e.key === "Enter") {
      onClick();
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ClickOutside, { onClickOutside }, showContextMenu && /* @__PURE__ */ React.createElement(DropdownMenu, { options: contextMenuData, onClose: onClickOutside }), showPlaybackMenu && /* @__PURE__ */ React.createElement(DropdownMenu, { options: playBackMenuData, onClose: onClickOutside })), /* @__PURE__ */ React.createElement(
    MoreSmall,
    {
      "data-hook": AUDIO_CONTEXT_MENU,
      tabIndex,
      onKeyPress,
      className: styles.audio_contextMenuIcon,
      onClick,
      "aria-label": "context menu"
    }
  ));
};
var ContextMenu_default = ContextMenu;
export {
  ContextMenu_default as default
};
//# sourceMappingURL=ContextMenu.js.map
